import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private count = 0;
  private _loading = new BehaviorSubject<boolean>(false);

  loading$ = this._loading.asObservable();

  show(): void {
    this.count++;
    this._loading.next(true);
  }

  hide(): void {
    this.count = Math.max(0, this.count - 1);
    if (this.count === 0) {
      this._loading.next(false);
    }
  }
}
